import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { logWebVitals } from "./reportWebVitals";
import { logPerformanceMetrics } from "./utils/performance";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Shared report pages, including malformed links, have no analytics setup.
const sharedReportRoute = /^\/care-report(?:\/|$)/.test(
  window.location.pathname,
);

// Measure and log Core Web Vitals
if (!sharedReportRoute) logWebVitals();

// Log additional performance metrics in development
if (!sharedReportRoute) logPerformanceMetrics();
